/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/**
 * © [2023 Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { withRouter } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { Tooltip } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import {
  getAllUserList,
  setErrorMessages,
  setGridData,
} from '../Store/actions';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import UserListHeader from './gridComponents/tableHead';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  closeTab,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';

function UserList(props) {
  const dispatch = useDispatch();
  const searchAllUserList = (value) => dispatch(getAllUserList(value));

  const resultData = useSelector((state) => {
    return state.sharedState.UserListReducer.userListData;
  });

  const errorMessages = useSelector((state) => {
    return state.sharedState.UserListReducer.errorMessages;
  });

  const gridData = useSelector((state) => {
    return state.sharedState.UserListReducer.gridData;
  });
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const [successMessages, setSuccessMessages] = useState([]);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = useState(false);
  const history = useHistory();

  const handleErrorMessages = useCallback(
    (messages) => {
      dispatch(setErrorMessages(messages));
    },
    [errorMessages]
  );

  const handleGridData = (value) => {
    dispatch(setGridData(value));
  };

  useEffect(() => {
    handleScrollToEvent();
  }, []);

  function getRole(arr) {
    let str = '';
    arr.forEach((el) => {
      if (el?.securityUserProvisionId?.ldapRoleId != 'Technical Window User') {
        if (str) {
          str = `${str}, ${el?.securityUserProvisionId?.ldapRoleId}`;
        } else {
          str = el?.securityUserProvisionId?.ldapRoleId;
        }
      }
    });
    return str;
  }
  function getStatusAlt(str) {
    let str1 = '';
    if (str === 'I') {
      str1 = 'Inactive';
    } else if (str === 'A') {
      str1 = 'Active';
    } else if (str === 'D') {
      str1 = 'Active & Disputes';
    } else {
      str1 = str;
    }
    return str1;
  }  
  useEffect(() => {
    if (logInUser && (!resultData?.data || resultData?.data?.length === 0)) {
      const values = {};
      searchAllUserList(values);
    }
  }, [logInUser]);

  useEffect(() => {
    if (resultData?.data && resultData?.data?.length > 0) {
      const gridDataResultValue = resultData?.data?.map((item) => ({
        userId: item?.userId,
        name: `${item?.firstName} ${item?.lastName}`,
        status: getStatusAlt(item?.userStatusCd),
        emailId: item?.emailAddr,
        roleDescription: getRole(item?.securityUserProvision),
      }));
      handleGridData(gridDataResultValue);
    }

    if (resultData?.error === 'API failed') {
      handleErrorMessages(['There are issues in processing your request']);
      setSuccessMessages([]);
    }
  }, [resultData]);

  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  const gridHeight = fullScreenView ? '70vh' : 400;

  const frameworkComponents = {
    nameRenderEmail: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.emailId;
      if (name && name.length > 31) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    nameRenderName: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.name;
      if (name && name.length > 18) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    nameRenderRole: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.roleDescription;
      if (name && name.length > 13) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    nameRenderStatus: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.status;
      if (name && name.length > 8) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
  };

  return (
    <div className="tBillPanel">
      <Spinner load={spinnerLoader} />
      <div className="panel tBillPanel-space devider-line pb-0">
        <div>
          <CustomSeparator parent1="System" parent2="User List" />
        </div>
        {!fullScreenView && (
          <div>
            <DisplayErrorMessages errorMessages={errorMessages} />
            <DisplaySuccessMessages successMessages={successMessages} />
          </div>
        )}
      </div>

      <div className="panel tBillPanel-space pb-0 frr-tbl-with-feature">
        <div className="clearfix" />
        <Grid
          rowData={gridData}
          columnDefs={UserListHeader}
          gridHeight={gridHeight}
          fileName="User List"
          enterMovesDown
          suppressCellFocus
          exportFile
          isScrollOn
          onCellFocused={onCellFocused}
          navigateToNextCell={navigateToNextCell}
          tabToNextCell={tabToNextCell}
          fullScreenView={fullScreenView}
          handleFullScreenViewClick={handleFullScreenView}
          frameworkComponents={frameworkComponents}
        />
      </div>
    </div>
  );
}
export default withRouter(UserList);
